import styled, { css } from 'styled-components';
import { Button } from '@lmn/design-system';

export type FooterLayout = 'full-width' | 'right' | 'left' | 'centered';

export const FooterButton = styled(Button)<{ $hugsLabel?: boolean }>`
  min-width: ${({ $hugsLabel }) => ($hugsLabel ? 'auto' : '140px')};
`;

const fullWidthChildren = (hasClear: boolean) => css`
  justify-content: ${hasClear ? 'space-between' : 'flex-end'};

  > * {
    width: ${hasClear ? '50%' : '100%'};
  }
`;

export const FooterContainer = styled.div<{
  hasClear: boolean;
  $sticky?: boolean;
  $showShadow?: boolean;
  $layout?: FooterLayout;
}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  ${({ $layout, hasClear }) => {
    if ($layout === 'full-width') return fullWidthChildren(hasClear);
    if ($layout === 'left')
      return css`
        justify-content: flex-start;
      `;
    if ($layout === 'centered')
      return css`
        justify-content: center;
      `;
    if ($layout === 'right')
      return css`
        justify-content: flex-end;
      `;
    return css`
      @media (max-width: 767px) {
        ${fullWidthChildren(hasClear)}
      }
    `;
  }}

  ${({ $sticky, theme }) =>
    $sticky &&
    css`
      position: sticky;
      bottom: 0;
      z-index: 1;
      padding: 16px;
      width: 100%;
      background-color: ${theme.kallisto.color.background.static.backgroundPage};
    `}

  ${({ $showShadow, theme }) =>
    $showShadow &&
    css`
      border-top: 1px solid ${theme.kallisto.color.border.static.borderNeutral};
      box-shadow: ${theme.kallisto.shadow.mediumTopShadow};
    `}
`;
